import type { GlobalErrorPage, SiteSettings } from '@/@types/content';
import withNav from '../hocs/withNav';
import ContentArea from '../cms/ContentArea';
import RichText from '../cms/RichText';

import { useNavigate } from 'react-router-dom';
import EditorialToutWithImageBlock from '../blocks/EditorialToutWithImageBlock';
import { LinkItem } from '@/@types/client-api';
import FallbackTextureImage from '../../assets/images/fallback-texture.png';

interface GlobalErrorPageProps extends GlobalErrorPage, SiteSettings {
  renderBackupContent?: boolean;
}

export const GlobalErrorPageComponent: React.FC<GlobalErrorPageProps> = props => {
  const navigate = useNavigate();
  const handleRetry = () => {
    navigate(-1);
  };

  return (
    <>
      <RichText content={props.mainBody} className="container module-spacing" />
      {props.renderBackupContent ? (
        <EditorialToutWithImageBlock
          smallImage={false}
          onPrimaryButtonClick={() => {
            navigate(0);
          }}
          heading="Page failed to load"
          copy={`In order to access it, please reload the page. If the issue persists please contact customer service at ${import.meta.env.VITE_APP_SERVICE_PHONE_NUMBER} or ${import.meta.env.VITE_APP_INFO_EMAIL}.`}
          link1RenderAsButton={true}
          aspectRadioLayout="1:1"
          link1Style="primary"
          requireAuthOnLinks={true}
          image={{
            url: FallbackTextureImage
          }}
          layout="media-right"
          imagePlacement="above-text"
          primaryLink={
            {
              title: 'Try Again',
              url: '',
              text: 'Try Again'
            } as LinkItem
          }
        />
      ) : (
        <ContentArea
          components={props.mainContentArea}
          propertyName="MainContentArea"
          componentsProps={{ onPrimaryButtonClick: handleRetry }}
        />
      )}
    </>
  );
};

const GlobalErrorPage = withNav(GlobalErrorPageComponent);

export default GlobalErrorPage;
